import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function CategoryNav() {
  return (
    <section id="category-nav" className="max-w-[1280px] mx-auto px-4 md:px-6 py-10">
      <div className="text-center mb-8">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
          动漫分类
        </h2>
        <p className="text-sm text-foreground-500">海量动漫资源，按分类快速找到你想看的</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
          >
            <div className="flex flex-col items-center text-center gap-2">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-accent-600 text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-400">{cat.count}+ 部</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}